import uuidv4 from 'uuid/v4'

export default {
  SET_USER (state, user) {
    state.user = user
  },
  SET_SETTINGS (state, settings) {
    state.settings = settings
  },
  ADD_FOOTER_ITEM (state, footerItem) {
    state.settings.footerItems.push(footerItem)
  },
  DELETE_FOOTER_ITEM (state, id) {
    state.settings.footerItems = state.settings.footerItems.filter(i => i.id !== id)
  },
  UPDATE_FOOTER_ITEMS (state, items) {
    state.settings.footerItems = items
  },
  UPDATE_FOOTER_ITEM (state, item) {
    Object.assign(state.settings.footerItems.find(i => i.id === item.id), item)
  },
  LOAD_MAIN_PAGE_PHOTO (state, settings) {
    state.settings.mainPagePhoto = settings.mainPagePhoto
  },
  CHANGE_POLICY_FILE (state, file) {
    state.settings.securityPolicyFile = file
  },
  CHANGE_AGREEMENT_FILE (state, file) {
    state.settings.agreementFile = file
  },
  CHANGE_INFO_MAILING_FILE (state, file) {
    state.settings.infoMailingFile = file
  },
  CHANGE_DEPOSITORY_CONSENT_FILE (state, file) {
    state.settings.depositoryConsentFile = file
  },
  ADD_SERVICES (state, services) {
    state.services = services
    if (!state.service && state.services[0]) {
      state.service = state.services[0]
    }
  },
  ADD_SERVICE (state, service) {
    state.service = service
    state.services = state.services.filter(s => !s.isNew)
  },
  ADD_CLIENTS (state, clients) {
    state.clients = clients
  },
  UPDATE_SERVICE (state, updatedService) {
    const menuItem = !updatedService.isNew
    ? state.services.find(s => updatedService.id === s.id)
    : state.services.find(s => s.isNew)
    menuItem.title = updatedService.title
    if (updatedService.isNew) {
      delete updatedService.isNew
      delete menuItem.isNew
      menuItem.id = updatedService.id
    }
    state.service.title = updatedService.title
    state.service = updatedService
  },
  UPDATE_SERVICE_ITEMS_ORDER (state, updatedService) {
    state.service = updatedService
  },
  LOAD_SERVICE_PHOTO (state, service) {
    state.service.photo = service.photo
  },
  ADD_ADVANTAGE (state, advantage) {
    state.service.advantages.push(advantage)
  },
  ADD_EXTRA_ADVANTAGE (state, advantage) {
    state.service.extraAdvantages.push(advantage)
  },
  DELETE_ADVANTAGE (state, id) {
    state.service.advantages = state.service.advantages.filter((a) => {
      return a.id !== id
    })
  },
  DELETE_EXTRA_ADVANTAGE ({ service }, id) {
    service.extraAdvantages = service.extraAdvantages.filter(advantage => advantage.id !== id)
  },
  UPDATE_ADVANTAGE (state, updatedAdvantage) {
    const advantage = state.service.advantages.find(a => a.id === updatedAdvantage.id)
    advantage.title = updatedAdvantage.title
    advantage.description = updatedAdvantage.description
  },
  UPDATE_EXTRA_ADVANTAGE (
    { service },
    { id, title, description, videoPreview, videoLink, buttonLink, buttonTitle, order, newPhoto }
  ) {
    const advantage = service.extraAdvantages.find(advantage => advantage.id === id)
    Object.assign(
      advantage,
      { id, title, description, videoPreview, videoLink, buttonLink, buttonTitle, order, newPhoto }
    )
  },
  ADD_REVIEW (state, review) {
    state.service.reviews.push(review)
  },
  UPDATE_REVIEW (state, updatedReview) {
    const review = state.service.reviews.find(r => r.id === updatedReview.id)
    review.title = updatedReview.title
    review.description = updatedReview.description
    review.result = updatedReview.result
    review.video = updatedReview.video
    review.photo = updatedReview.photo
  },
  DELETE_REVIEW (state, id) {
    state.service.reviews = state.service.reviews.filter((review) => {
      return review.id !== id
    })
  },
  DELETE_PRINCIPLE (state, id) {
    state.service.principles = state.service.principles.filter((advantage) => {
      return advantage.id !== id
    })
  },
  ADD_PRINCIPLE (state, principle) {
    state.service.principles.push(principle)
  },
  UPDATE_PRINCIPLE (state, updatedPrinciple) {
    let principle = state.service.principles.find(p => p.id === updatedPrinciple.id)
    principle.title = updatedPrinciple.title
    principle.description = updatedPrinciple.description
  },
  UPDATE_BECOME_CLIENT_DATA (state, data) {
    Object.assign(state.service.becomeClientData.find(d => d.id === data.id), data)
  },
  DELETE_BECOME_CLIENT_DATA (state, id) {
    state.service.becomeClientData = state.service.becomeClientData.filter(d => d.id !== id)
  },
  ADD_BECOME_CLIENT_DATA (state) {
    state.service.becomeClientData.push({
      title: '',
      text: '',
      id: uuidv4()
    })
  },
  ADD_RATE (state, rate) {
    state.service.rates.push(rate)
  },
  UPDATE_RATE (state, updatedRate) {
    const rate = state.service.rates.find(r => r.id === updatedRate.id)
    rate.title = updatedRate.title
    rate.description = updatedRate.description
    rate.symbol = updatedRate.symbol
  },
  DELETE_RATE (state, id) {
    state.service.rates = state.service.rates.filter((rate) => {
      return rate.id !== id
    })
  },
  CHANGE_REVIEW_PHOTO (state, updatedReview) {
    const review = state.service.reviews.find(s => s.id === updatedReview.id)
    review.photo = updatedReview.photo
  },
  DELETE_SERVICE (state, service) {
    state.services = state.services.filter(s => s.id !== state.service.id)
    state.service = null
  },
  UPDATE_SERVICE_ITEM (state, service) {
    Object.assign(state.services.find(s => s.id === service.id), service)
  },
  UPDATE_SERVICE_ORDER (state, service) {
    state.services = state.services.filter(s => s.id !== service.id)
    state.services.splice(service.indexNumber, 0, service)
  },
  ADD_NEW_SERVICE (state) {
    const newService = {
      'isMain': true,
      'title': 'Новая услуга',
      'additionalInfo': null,
      'learnMoreButton': {
        title: '',
        url: ''
      },
      'groupNumber': 3,
      'description': null,
      'text': null,
      'showCalculator': false,
      'photo': null,
      'ratesComparisonFile': null,
      'isHidden': false,
      'indexNumber': state.services.length + 1,
      'mainPagePhoto': null,
      'hideOnMain': false,
      'service_id': null,
      'reviews': [],
      'advantages': [],
      'extraAdvantagesTitle': null,
      'extraAdvantages': [],
      'principles': [],
      'rates': [],
      'promo': null,
      'concomitantService': null,
      'isNew': true,
      'id': 'new'
    }
    state.services.push(newService)
    state.service = newService
  },
  ADD_PROMOS (state, promos) {
    state.promos = promos
  },
  ADD_SERVICE_PROMOS (state, promos) {
    state.servicePromos = promos
  },
  UPDATE_PROMO (state, promo) {
    Object.assign(state.promos.find(p => p.id === promo.id), promo)
  },
  ADD_NEW_PROMO (state, promo) {
    state.promos.unshift(promo)
  },
  LOAD_SERVICE_MAIN_PAGE_PHOTO (state, updatedService) {
    const service = state.services.find(s => s.id === updatedService.id)
    service.mainPagePhoto = updatedService.mainPagePhoto
  },
  CHANGE_PROMO_PHOTO (state, newPromo) {
    let promo = state.promos.find(s => s.id === newPromo.id)
    promo.photo = newPromo.photo
  },
  DELETE_PROMO (state, id) {
    state.promos = state.promos.filter((promo) => {
      return promo.id !== id
    })
  },
  ADD_NOTIFICATIONS (state, news) {
    state.news = news
  },
  CHANGE_RATES_FILE (state, file) {
    state.service.ratesComparisonFile = file
  },
  DEL_NOTIFICATIONS (state, id) {
    state.news = state.news.filter(article => article.id !== id)
  },
  ADD_EMITENTS (state, emitents) {
    state.emitents = emitents
  },
  ADD_EVENTS (state, events) {
    state.events = events
  },
  DEL_EVENTS (state, events) {
    state.events = state.events.filter(event => !events.includes(event.id))
  },
  SET_SOFTWARE (state, { packages, apps }) {
    state.software.packages = packages
    state.software.apps = apps
  },
  DEL_SOFTWARE_PACKAGE (state, id) {
    state.software.packages = state.software.packages.filter(pack => pack.id !== id)
  },
  SET_SOFTWARE_APPS (state, apps) {
    state.software.apps = apps
  },
  DEL_SOFTWARE_APP (state, id) {
    state.software.apps = state.software.apps.filter(app => app.id !== id)
  },
  ADD_FILE (state, { appId, file }) {
    if (state.software.apps.find(app => app.id === appId)) {
      state.software.apps.find(app => app.id === appId).files.push(file)
    }
  },
  UPDATE_SETTINGS (state, settings) {
    Object.assign(state.settings, settings)
  },
  LOAD_FILES_STORAGE (state, files) {
    state.files = files
  },
  SET_CLAIM_INFO (state, claimInfo) {
    state.claimInfo = claimInfo
  },
  UPDATE_CLAIM_INFO (state, updatedClaimInfo) {
    state.claimInfo = updatedClaimInfo
  },
  SET_CLAIMS (state, claims) {
    state.claims = claims
  },
  ADD_CLAIM (state, claim) {
    state.claims.push(claim)
  },
  REMOVE_CLAIM (state, id) {
    const index = state.claims.findIndex(claim => claim.id === id)
    state.claims.splice(index, 1)
  },
  UPDATE_CLAIM (state, updatedClaim) {
    const index = state.claims.findIndex(claim => claim.id === updatedClaim.id)
    state.claims[index] = updatedClaim
  },
  SET_APP_OPERATIONS (state, operations) {
    state.submissionAppOperations = operations
  }
}



// WEBPACK FOOTER //
// ./src/store/mutations.js